export const DEFAULT_STATUS = {
  loading: false,
  activeUser: null,
  activeAuthenticator: null,
  users: [],
  error: null,
  message: '',
}
